import React from 'react';
import { Ticket } from 'lucide-react';

/**
 * Shown when filters match nothing, and when the camp has no coupons at all — the two cases read
 * differently enough to be worth distinguishing, since the first is recoverable by clearing
 * filters and the second is not.
 */
const CouponEmptyState = ({ filtersApplied, onClearFilters, onCreate }) => (
    <div className="cpn-flex cpn-flex-col cpn-items-center cpn-gap-2 cpn-px-6 cpn-py-20 cpn-text-center">
        <Ticket className="cpn-h-8 cpn-w-8 cpn-text-neutral-300" aria-hidden="true" />

        {filtersApplied ? (
            <>
                <p className="cpn-text-base cpn-font-semibold cpn-text-neutral-900">
                    No coupon codes match
                </p>
                <p className="cpn-text-sm cpn-text-neutral-500">
                    Try a different search term, or reset your filters.
                </p>
                <button
                    type="button"
                    onClick={onClearFilters}
                    className="cpn-mt-2 cpn-rounded-lg cpn-border cpn-border-neutral-200 cpn-px-4 cpn-py-2 cpn-text-sm cpn-font-semibold cpn-text-neutral-700 cpn-transition hover:cpn-bg-neutral-50"
                >
                    Clear filters
                </button>
            </>
        ) : (
            <>
                <p className="cpn-text-base cpn-font-semibold cpn-text-neutral-900">
                    No coupon codes yet
                </p>
                <p className="cpn-text-sm cpn-text-neutral-500">
                    Create a code to offer families a discount at checkout.
                </p>
                <button
                    type="button"
                    onClick={onCreate}
                    className="cpn-mt-2 cpn-rounded-lg cpn-bg-brand-700 cpn-px-4 cpn-py-2 cpn-text-sm cpn-font-semibold cpn-text-white cpn-transition hover:cpn-bg-brand-800"
                >
                    Create Coupon Code
                </button>
            </>
        )}
    </div>
);

export default CouponEmptyState;
